/* A generic live-JSON panel — pretty-prints any value. Sections pass their
 * state-derived config object so users see the real JSON update as they build. */
export function JsonPanel({ value, title = "Live JSON" }: { value: unknown; title?: string }) {
  let text: string;
  try {
    text = JSON.stringify(value, null, 2);
  } catch {
    text = String(value);
  }
  return (
    <div className="gd-json">
      <div className="gd-col-head">{title}</div>
      <pre className="gd-json-pre"><code>{text}</code></pre>
    </div>
  );
}
